<template>
    <div class="rounded" v-if="(!section.omitted) || showOmitted ">
        <div class="flex items-center mb-0 mt-2">
            <div class="w-6 flex-shrink-0">
            </div>
            <div class="flex-grow">
                <div
                    class="whitespace-pre-line text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 resize-none"
                    :class="section.omitted?'text-red-600 line-through':'text-gray-900'"
                    v-text="name"
                ></div>
            </div>
            <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            </div>
        </div>
        <cost-plan-task v-for="task in section.tasks" :key="task.id"
                                :cost-plan="costPlan"
                                :showItemProgress="showItemProgress"
                                :show-omitted="showOmitted"
                                :readonly="readonly || section.omitted"
                                :currentItem="currentItem"
                                @updated="$emit('updated')"
                                @toggleBuildup="(i) => $emit('toggleBuildup',i)"
                                :latest-progress-report="latestProgressReport"
                                :section="section" :task="task"
                                :ref="(readonly?'readonly-':'')+'tasks'"></cost-plan-task>
    </div>
</template>

<script>
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import {toCurrency, uuid} from "../../../utils";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import CostPlanTask from "./CostPlanTask.vue";
import ContractedWorksSection from "../contracted-works/ContractedWorksSection.vue";

export default {
    components: {
        ContractedWorksSection,
        CostPlanTask,
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
    },
    props: {
        costPlan: Object,
        section: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        readonly: true,
        currentItem: null,
        latestProgressReport: Object,
    },
    data() {
        return {
            name: this.section.name,
            proposedStatus: this.section.proposedStatus,
            status: this.section.status,
            original: this.latest ? this.latest.sections.find((i) => i.id === this.section.id) : null,
            totalValueKey: 0,
        }
    },
    computed: {
    },
    methods: {
        canEdit() {
            return (!this.readonly)
        },
        canMove() {
            return (!this.readonly) && (this.proposedStatus === 'ADDED');
        },
    },
}
</script>
